import { isPresent } from "src/utils/checks";

type PartialLocalizedMicroContent<T> = T extends {
  _key?: string;
  code?: string;
  label?: { localized?: string };
  content?: { localized?: string };
}
  ? T
  : never;

type ActualLocalizedMicroContent<T> = Omit<
  PartialLocalizedMicroContent<T>,
  "label" | "content" | "_key" | "code"
> & {
  _key: string;
  code: string;
  label?: string | undefined;
  content?: string | undefined;
};

export function toLocalizedMicroContents<T>(
  microContents: (PartialLocalizedMicroContent<T> | undefined)[] | undefined
) {
  return (microContents || []).map(localizedMicroContent).filter(isPresent);
}

function localizedMicroContent<T>(
  microContent: PartialLocalizedMicroContent<T> | undefined
): ActualLocalizedMicroContent<T> | undefined {
  if (!microContent) return undefined;

  const { label, content, _key, code, ...rest } = microContent;
  if (!code || !_key) return undefined;

  return {
    ...rest,
    _key,
    code,
    label: label?.localized
  };
}
